import { FuelToast } from '@frete.com/fuel-react';
import { FC, useEffect, useRef } from 'react';

import { useToast } from '@/hooks';

import { ToastProps } from './types';

const Toast: FC<ToastProps> = ({ type, title, description, id }) => {
  const ref = useRef<HTMLFuelToastElement>();
  const toast = useToast();

  const onClose = () => {
    toast.remove(id);
  };

  const openToast = async () => {
    if (ref?.current.open) {
      await ref?.current.open();
    }
  };

  useEffect(() => {
    openToast();
  }, [ref]);

  return (
    <FuelToast severity={type} heading={title} message={description} ref={ref} onClick={onClose} data-testid="toast" />
  );
};

export { Toast };
